import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Input,
  TabPane,
  Table,
  InputGroup
} from "reactstrap"
import classnames from "classnames"
import { isEmpty } from "lodash"
import  { useHistory } from  'react-router-dom'
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "../../axios"
import numeral from "numeral";
import { makeStyles } from '@material-ui/core/styles';
import  Spinner  from 'react-spinkit'
import Backdrop from '@material-ui/core/Backdrop';
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
//Import actions
import { getProductDetail } from "../../store/actions"
import SweetAlert from "react-bootstrap-sweetalert";

const EcommerceProductDetail = props => {
  const {
    product,
    match: { params },
    onGetProductDetail,
  } = props
  const history = useHistory()
  
  const [activeTab, setActiveTab] = useState("1")
  const [activeDescriptionTab, setDescriptionActiveTab] = useState("specifications")
const [allgetoneproducts , setallgetoneproducts ] = useState([])
const [tokent, settokent] = useState('Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ')
const [allprodutarra, setallprodutarra] = useState([])
const [totalqty, settotalqty] = useState('')
const [provalue , setprovalue ] = useState([])
const [purchaseqtys, setpurchaseqtys] = useState(1)
const [Purchasesavess, setPurchasesavess] = useState(false)
const [dailoa1, setdailoa1] = useState(false)
const classes = useStyles();
const [allvirtualstocks, setallvirtualstocks] = useState([])
const [allstockinhand, setallstockinhand] = useState([])
const [TOtaligstamt, setTOtaligstamt] = useState('')
const [CGstid, setCGstid] = useState('')
const [Sgstid, setSgstid] = useState('')
const [GStId, setGStId] = useState('')
var imageDefault = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAANlBMVEX///+/v7+8vLzKysr8/Pzg4ODFxcXb29vT09Pj4+P4+PjBwcH6+vry8vLY2NjIyMjs7Ozo6Oia8u11AAAEdUlEQVR4nO2d65bqIAxGp/Smrb34/i971KqlEC7FGuJZ3/7dKewJBgK4/PsDAAAAAAAAAAAAAAAA4KUam5+i3m94UsUPoVoYwlA6MIShfGAIQ/nAEIbyOcBQSeNww9NZGOXBhuq8+w1fxugfDG1gmB0YBoFhdmAYBIbZgWEQGGYHhkFgmB0YBoFhdmAYBIbZyWB4qVI6mgyv4WUeH7u007lL7vFeWA3n8rUFrZqWK5KchnWvPapOTGFkNDQPOJrhk45Hw2d4Ns+oVPlRz2NhMxyawkTtv2OWAJvhSBwzfjBO2+g/5TLs7BDeSF4eDP0Y+yiX4UydFKtT4pRxa3SKTcVchtQgLYrobhq0Kj7+XIb0aX+fZtipHfH/ScPlZZG5Jq9hk2RYP96lTnFPcxnWpGF52d2eNrPGPc5lOJC5NDrl65Sv1fs16nEuw8v20sdCP+9uTh8NZVSuYVvTnKlBmjAdaqu/uH8Qm2FVWuNUJYSwOu3tLV9tcelNw5SF9yZjRaVixvpwbrZRTKnyuyKysRXOGn/QBqpK25QzptVm9598eyfqXDaPnah+GlNmwr/aGOcqYl3DvJtYzXU7jvU1bbVmVdExE+pP7Qjb6TiiOBFmOPuyD7XyC+djWYadGt2KxE5PzMpWluHtXc6KQZ/rNYK5RpThfWXnrGzp6iRcQ0ky7KbHK+iBup3rtQZD6wZJhq+9HDIsri89BBsUZPguIal0Y871K6ECRY6hXkFaimQeXQjVUHIMNwWkuVax5/q1xcC6Rozh0G+7vYmidaqzCaJ/whBjaEZJr608Y7QIHvBIMbR3/dfB55jr3/hrKCGGxMHN+vmi53rtSW+uEWLYUj1/dsY1169tetc1MgwHaw9HU3TN9Svec0huw4os6CZHcO7dcc/163O+XMNteC0JRfdk0Aby6BNfDcW9i1EquzedI4R36vAYLfy5htnwtnBRvaHo/SZxjN8Nz7UO5ltf97WnMgbqHCfhRbmHKa/hdXl2qxjzQQsaunMNr+FzUlD62W8bORD9TM4gshpe3xVg+Z7BonJlmN55mMhpWGkV4GughtacsbgvLnAa6hXga6B666I9OGsoRsPtMbCa7l2q6OVaAs6uMxpejXDdd+SPSTMP+vyGdri6+bAQui8u8BmaIbwxUdcXkg0dNRTjOf6BNiSOGirrXYxjcXQ+632ag6EPE7kMiU/h4dA1FJfhgUnTzZTRkCOEt8apYcpj+P1E6u4+j+H3E+kCdUmKxZAjkS4QrbMY8nwKC7qGYjFkSaQL9rqGw5AthORhIoMhUyJ9ksPwsDI+Brv97xtWY8mJNUwZYtixYu0qyjhd+yYwDALD7MAwCAyzA8MgMMwODIPAMDtHGxZ1JYvjDRvWajCC7SYRfhsBhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvKBIQzlA0MYygeGMJQPDGEoHxjCUD4whKF8YAhD+cAQhvJJM/wpEgyv9U+R8iNaAAAAAAAAAAAAAAAAAP4r/gEYCYE2Xwz6DQAAAABJRU5ErkJggg=='
const [productexits, setproductexits] = useState(false)
const [stockinhands, setstockinhands] = useState('')
const [virturalstocksss, setvirturalstocksss] = useState('')
const [pendigsoqty, setpendigsoqty] = useState([])
const [soqtypending, setsoqtypending] = useState('')
const [popendingpurchase, setpopendingpurchase] = useState([])
const [salesqtyerror, setsalesqtyerror] = useState(false)
  useEffect(() => {
    if (params && params.id) {
      onGetProductDetail(params.id)
    } else {
      onGetProductDetail(1)

    }
    getpendingsoqty()
    Getoneproducts()
    Getallvirtualstock()
    Getallstockinhand()
    getpopendingstocks()
    ////////////console.log(props.match.params.id)
  }, [onGetProductDetail, params])

  const toggleTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }
  const getpopendingstocks  = async() => {
    const get= await axios.instance.get(`/getpopendings/${props.match.params.id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then((res) => {
      ////console.log(res.data,'virtural')
 
  setpopendingpurchase(res.data)

    })
    }
  const toggledescription = tab => {
    if (activeDescriptionTab !== tab) {
      setDescriptionActiveTab(tab)
    }
  }

  const imageShow = (img, id) => {
    const expandImg = document.getElementById("expandedImg" + id)
    expandImg.src = img
  }
  const Getoneproducts  = async() => {
    const get= await axios.instance.get(`/Getoneproducts/${props.match.params.id}`,{ headers: {'Authorization':tokent,
    'Content-Type': 'application/json',
    
    }}).then(async(res) => {
      for(const data of res.data) {
        for(const data of res.data) {
          const cgst =  await axios.instance.get(`/Getalltaxpercentage/CGST/${data.CGSTPer}`, {headers: { 'Authorization': tokent,'Content-Type': 'application/json'}})
          const sgst =  await axios.instance.get(`/Getalltaxpercentage/SGST/${data.SGSTPer}`, {headers: { 'Authorization': tokent,'Content-Type': 'application/json'}})
        const Igst =  await axios.instance.get(`/Getalltaxpercentage/IGST/${data.VAT_Percentage}`, {headers: { 'Authorization': tokent,'Content-Type': 'application/json'}})
        //////////////console.log('SGstid', sgst.d)  
        for(const data of cgst.data) {
           
            setCGstid(data.TaxId)
         }
          for(const data of sgst.data) {
        
           setSgstid(data.TaxId)
         }
         for(const data of Igst.data) {
        
           setGStId(data.TaxId)
         }
      
        
        }
      }
  setallgetoneproducts(res.data)

    })
    }
    const Getallstockinhand  = async() => {
      const get= await axios.instance.get(`/Getallstockinhand/${props.match.params.id}`,{ headers: {'Authorization':tokent,
      'Content-Type': 'application/json',
      
      }}).then((res) => {
        for(const data of res.data) {
          setstockinhands(data.PrimaryStock)
        }
    setallstockinhand(res.data)
  
      })
      }
      const Getallvirtualstock  = async() => {
        const get= await axios.instance.get(`/Getallvirtualstocks/${props.match.params.id}`,{ headers: {'Authorization':tokent,
        'Content-Type': 'application/json',
        
        }}).then((res) => {
          for(const data of res.data) {
            setvirturalstocksss(data.PrimaryStock)
          }
      setallvirtualstocks(res.data)
    
        })
        }

        const getpendingsoqty  = async() => {
          const get= await axios.instance.get(`/getpopendingsoqty/${localStorage.getItem('CompanyId')}/${props.match.params.id}`,{ headers: {'Authorization':tokent,
          'Content-Type': 'application/json',
          
          }}).then((res) => {
            for(const data of res.data) {
              setsoqtypending(data.pendingsoqty)
            }
        setpendigsoqty(res.data)
      
          })
          }
    
const getproductinfo = () => {
  if(purchaseqtys >0) {

  
  let cartproducts = []
  let prod =   localStorage.getItem('Salescart')
  if( prod != null  ) {
    const getdata = JSON.parse( prod ) 
    for(const data of getdata){
    ////////console.log(data)
     cartproducts.push(data)
     
    }

   
    }
  for(const data of allgetoneproducts){
    ////////console.log(data)
    cartproducts.push({
      Product_Details_Description:data.Product_Details_Description,
     // PO_Id:localStorage.getItem('Purid'),
     Product_Details_Id:data.Product_Details_Id,
     UOM_Id:data.UOM_Id,
      Order_Qty:parseFloat(purchaseqtys),
      Rate:parseFloat(data.Sales_Rate),
      CST_Percentage:data.CGSTPer  === '' ? 0 : data.CGSTPer ,  
      VAT_Percentage:data.CGSTPer === '' ? 0 : data.CGSTPer ,
      Discount:0,
      Amount:1,
      Update_DC_Qty:0,
      update_sales_bill_qty:1,
      PoSlNo:1,
      OtherDesc:1,
      TaxId:CGstid,  
      PriUOM_Id:data.UOM_Id,
      GSTPer:parseFloat(data.CGSTPer + data. SGSTPer) === '' ? 0 : parseFloat(data.CGSTPer + data. SGSTPer),
      SGSTId:Sgstid,
      SGSTPer:parseFloat(data.SGSTPer)  === '' ? 0 : parseFloat(data.SGSTPer),
      IGSTId:GStId,
      IGSTPer:parseFloat(data.CGSTPer + data. SGSTPer) === '' ? 0 : parseFloat(data.CGSTPer + data. SGSTPer),
      PriUOM_Id:data.UOM_Id,
      PriOrder_Quantity:parseInt(purchaseqtys),
      PriRate:parseFloat(data.Sales_Rate),
      ConQty:parseInt(purchaseqtys),
      Act_UOM:data.UOM_Id,
      Act_Rate:parseFloat(data.Sales_Rate),
      Act_Qty:parseInt(purchaseqtys),
      DisAmt:0,
      Sec_UomId:data.UOM_Id,
      Imagepath:data.Imagepath,
      UOMtype:"P",
      DutyPer:0,
      Duty_Id:0,
      Lpo_Id:0
     



    })
    const unique = [];
    cartproducts.map(x => unique.filter(a => a.Product_Details_Id == x.Product_Details_Id).length > 0 ? null : unique.push(x));
    
    
    localStorage.setItem('Salescart',  JSON.stringify(unique))
    let Getprod =   localStorage.getItem('Salescart')

localStorage.setItem('Salescartcount',unique.length)

    let prodvalues = JSON.parse(Getprod)
    ////////////console.log(prodvalues)
  setprovalue(prodvalues)
    let qtytotal = []
    
    for(const data of prodvalues){
    qtytotal.push(parseFloat(data.Order_Qty))
    }
    var qtyvalue = 0 
    for (let i = 0; i < qtytotal.length; i++) {
      qtyvalue += qtytotal[i];
    }
    settotalqty(qtyvalue)
    ////////////console.log(qtyvalue)
    localStorage.setItem('TotalQty1',qtyvalue)
//history.push('/Purchaseorder')
let taxtotal = []
for(const data of prodvalues) {
taxtotal.push(parseFloat(data.GSTPer))
}

var taxvalue = 0
for(let i =0; i< taxtotal.length; i++) {
taxvalue += taxtotal[i]
}
localStorage.setItem('taxvalue1',taxvalue)
let  totalnetamount = []
for(const data of prodvalues) {
  totalnetamount.push(parseFloat(data.Rate * data.Order_Qty))
 // ////////////console.log('totalamount',totalnetamount )
}
var totalsumamount = 0
for(let i =0; i< totalnetamount.length; i++) {
  totalsumamount += totalnetamount[i]
  }

//  ////////////console.log('test',totalsumamount)
localStorage.setItem('Totalsumamounts1',totalsumamount)

let  totalsalesrate = []
for(const data of prodvalues) {
  //////console.log(data.Order_Qty,'datass')
  // totalsalesrate.push(numeral((numeral((data.Rate)/(100 + data.GSTPer)*100)).format('0,0.00') * parseFloat(data.Order_Qty)).format('0,0.00'))
totalsalesrate.push(parseFloat((((((data.Rate)/(100 + data.GSTPer)*100)))* parseFloat(data.Order_Qty))))


}
var totalsalescount = 0
for(let i =0; i< totalsalesrate.length; i++) {
  totalsalescount += totalsalesrate[i]
}
//settotalamt(totalnetcount)
//AsyncStorage.setItem('Totalamt', totalnetcount.toString())
//localStorage.setItem('Totalsumamounts1',totalnetcount)


localStorage.setItem('totalsalesrate',totalsalescount)



let totalIgstamt = []
for(const data of prodvalues) {
totalIgstamt.push(parseFloat((data.Rate * data.Order_Qty) * data.GSTPer/100))
//////////////console.log('igst', data.IGSTPer)
}
var  totalIgstvalu = 0
for(let i=0; i< totalIgstamt.length; i++) {
totalIgstvalu +=totalIgstamt[i]
}
////////////console.log('checkl',totalIgstvalu)
//settotaltax(totalcgstvalu +totalcgstvalu)
setTOtaligstamt(parseFloat(totalIgstvalu))
////////////console.log(totalIgstvalu)
localStorage.setItem('Totaligstvalue1',totalIgstvalu)



let totalsalesigstvaleu = []
    for(const data of prodvalues) {
      //////console.log(data)
      totalsalesigstvaleu.push(parseFloat(((((data.Rate)/(100 + data.GSTPer)*100)* parseFloat(data.Order_Qty)) * data.GSTPer)/100))
    ////////////console.log('igst', data.IGSTPer)
    ////////console.log('test', data.GSTPer)
    //////console.log(totalsalescount,'det')
    }
    var  totalsalesamt = 0
    for(let i=0; i< totalsalesigstvaleu.length; i++) {
      totalsalesamt +=totalsalesigstvaleu[i]
      
    }
    localStorage.setItem('totalsalesgstamt',totalsalesamt)
if(unique.length === cartproducts.length ) {

 



  
 }else {
  setproductexits(true)
// //const totalamtvalueget =  await AsyncStorage.getItem('Totalamt')


 }



  }

setdailoa1(true)
setPurchasesavess(true)
setTimeout(() => {
  setdailoa1(false)
  setPurchasesavess(true)
  history.push('/Salesorder')
}, 3000);
}else{
  setsalesqtyerror(true)
  setTimeout(() => {
    setsalesqtyerror(false)
  }, 2000);
}
}














  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Purchase Order" breadcrumbItem="Product Detail" />
          
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xl="5">
                        <div className="product-detail">
                          <Row>
                           
                            <Col xs="9">
                              <TabContent activeTab={activeTab} className="position-relative">
                                <div className="product-wishlist">
                                  {/* <Link to="#">
                                    <i className="mdi mdi-heart-outline"></i>
                                  </Link> */}
                                </div>
                               
                              </TabContent>
                              <Row className=" text-center mt-3">
                                {/* <div className="col-sm-6 d-grid">
                                <Link to="/Purchase-ordercart">
                                  <Button
                                    type="button"
                                    color="primary"
                                    className="btn-block waves-effect waves-light mt-2 me-1"
                                  >
                                    <i className="uil uil-shopping-cart-alt me-2"></i> Add to cart
                                </Button>
                                </Link>
                                </div> */}
                              {allgetoneproducts.map((data)=> (
<div key={data.Product_Details_Id}  className="product-img pt-2 px-2 hover14 column">
                            
                              
                                           
                            <figure>
   <img src={`${data.Imagepath}`} 
   
    style={{width:'200px', height:'200px',}}
     alt="" className="img-fluid mx-auto d-block "
     onError={({ currentTarget }) => {
       currentTarget.onerror = null; // prevents looping
       currentTarget.src=imageDefault;
     }}
      
     /> 
    </figure>
                                 </div>
  ))}
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col xl="7">
                        <div className="mt-4 mt-xl-3 ps-xl-4">
                  
    

                          <div>
                            <Row>
                              <Col md="8">
                             
                                
                              <div  className="mt-3">
                              {allgetoneproducts.map((data)=> (
                                  <h6   key={data.Product_Details_Id} className="font-size-13"> {data.Brand}</h6>
                                  ))}
                               
                                        {allgetoneproducts.map((data)=> (
                                  <h5   key={data.Product_Details_Id} className="font-size-18">{data.Product_Details_Description}</h5>
                                  ))}
                                 
                                      {allgetoneproducts.map((data)=> (
                                  <h5   key={data.Product_Details_Id} className="font-size-13">Design: {data.Design}</h5>
                                  ))}
                              
                                     {allgetoneproducts.map((data)=> (
                                  <h5   key={data.Product_Details_Id} className="font-size-14">Uom: {data.UOM_Description}</h5>
                                  ))}
                                  {allgetoneproducts.map((data)=> (
                                  <h5   key={data.Product_Details_Id} className="font-size-17">₹ {numeral(data.Sales_Rate).format('0,0.00')}</h5>
                                  ))}
                               
                                  {allstockinhand.map((data)=> (
                                  <h5  key={data.Product_Details_Id} className="font-size-11" style={{marginTop:"30px"}}>Stock In Hand: {numeral(data.PrimaryStock).format('0,0.00')}</h5>
                                  ))}
                                    {allstockinhand.map((data)=> (
                                  <h5  key={data.Product_Details_Id} className="font-size-11 mb-3 text-start" style={{marginTop:-24,marginLeft:"180px"}}>Pending So Stock: { numeral(soqtypending).format('0,0.00')}</h5>
                                  ))}
                  <h5   className="font-size-11 mb-3 text-start" >Needed Stock: { numeral(virturalstocksss + stockinhands).format('0,0.00') >=0 ? numeral(0).format('0,0.00') :  numeral(parseFloat(virturalstocksss)+parseFloat(stockinhands)).format('0,0.00')}</h5>                               
                  {popendingpurchase.map((data)=> (
                                     <h5 key={data.Product_Details_Id} style={{marginTop:-30,marginLeft:"180px"}}  className="font-size-11 mb-3  " >Pending Po Stock: { numeral(data.billedqty).format('0,0.00')}</h5>                               
                                     ))}
                                </div>
                               
                               
                               
                              </Col>
                             
                            </Row>
                            {/* <div className="product-color">
                              <h5 className="font-size-15">Color :</h5>
                              {product.colorOptions &&
                                product.colorOptions.map((option, i) => (
                                  <Link to="#" className="active" key={i}>
                                    <div className="product-color-item border rounded">
                                      <img
                                        src={option.image}
                                        alt=""
                                        className="avatar-md"
                                      />
                                    </div>
                                    <p>{option.color}</p>
                                  </Link>
                                ))}
                            </div> */}
                          </div>
                          <div className="col-md-4">
                          <div className="mt-3">
                            <p className=" mb-2">Quantity</p>
                            <div
                              style={{ width: "120px" }}
                              className="product-cart-touchspin"
                            >
                              <InputGroup className="bootstrap-touchspin bootstrap-touchspin-injected">
                              <span className="input-group-btn input-group-append">
                                  <Button
                                    color="primary"
                                    onClick={() => {
                             if(purchaseqtys > 1) {
                            
                                        setpurchaseqtys(parseInt(purchaseqtys)-1)
                                      
                             }
                                     }}
                                    className="bootstrap-touchspin-up"
                                  >
                                    -
                                  </Button>
                                </span>
                              
                                <Input
                                
                                  value={purchaseqtys}
                                  name="demo_vertical"
                                  onChange={(e)=> {

                                
                                    
                                 
                                    setpurchaseqtys(e.target.value)
                                  
                                } }
                                />
                                <span className="input-group-btn input-group-prepend">
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                     setpurchaseqtys(parseInt(purchaseqtys)+1)
                                    }}
                                    className="bootstrap-touchspin-down"
                                  >
                                    +
                                  </Button>
                                </span>
                              </InputGroup>
                            </div>
                            {salesqtyerror ? <p  className="error">Please Enter Qty </p> :  null}
                          </div>
                        </div> 
                          <Row>
                        
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  

<div className="col-sm-6 d-grid">
                                   
                                  <Button
                                    type="button"
                                    color="primary"
                                    className="btn-block waves-effect  mt-2 waves-light"
                                    onClick={getproductinfo}
                                    size="sm"
                                    style={{width:"110px"}}
                                  >
                                    <i className="uil uil-shopping-cart-alt me-2"></i> Add to cart
                                </Button>
                             

                                </div> 

                  </CardBody>
                </Card>
              </Col>
            </Row>
     
        </Container>
      </div>
      {dailoa1 ? (
      <Backdrop  open={dailoa1} className={classes.backdrop} >
      <Spinner name="ball-spin-fade-loader"  color='#fafafa' />

     </Backdrop>
      ): null}
      {Purchasesavess ? (
                    <SweetAlert
                      title="Product Added Successfully"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      success
                      onConfirm={() => {
                        setPurchasesavess(false);
                      }}
                    ></SweetAlert>
                  ) : null}
   {productexits ? (
                    <SweetAlert
                      title="Product Already Added In Cart"
                      timeout={2000}
                      style={{
                        position: "absolute",
                         justifyContent:'center',
                         alignItems:'center'
                      }}
                      showCloseButton={false}
                      showConfirm={false}
                      danger
                      onConfirm={() => {
                        setproductexits(false);
                      }}
                    ></SweetAlert>
                  ) : null}


    </React.Fragment>
  )
}

EcommerceProductDetail.propTypes = {
  product: PropTypes.object,
  onGetProductDetail: PropTypes.func,
}

const mapStateToProps = ({ ecommerce }) => ({
  product: ecommerce.product,
})

const mapDispatchToProps = dispatch => ({
  onGetProductDetail: id => dispatch(getProductDetail(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EcommerceProductDetail)
